import { CaretIcon } from "../Icons/Icons";
import useEmblaCarousel from "embla-carousel-react";
import { useEffect } from "react";

interface Props {
    roomIndex: number;
    setRoomIndex: React.Dispatch<React.SetStateAction<number>>;
    roomNames: string[]
}

const RoomPagination: React.FC<Props> = ({ roomIndex, setRoomIndex, roomNames }) => {
    const [paginationContainerRef, paginationContainerApi] = useEmblaCarousel({
        containScroll: "keepSnaps",
        dragFree: true
    });

    /* Con esto se scrollea instantáneamente al índice del departamento seleccionado
       por el usuario en la página de inicio. */
    useEffect(() => {
        paginationContainerApi?.scrollTo(roomIndex, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationContainerApi])

    const nextRoom = () => {
        const nextIndex = (roomIndex + 1) % roomNames.length;
        setRoomIndex(nextIndex);
        paginationContainerApi?.scrollTo(nextIndex);
    };

    const prevRoom = () => {
        const prevIndex = (roomIndex - 1 + roomNames.length) % roomNames.length;
        setRoomIndex(prevIndex);
        paginationContainerApi?.scrollTo(prevIndex);
    };

    const handleRoomClick = (index: number) => {
        setRoomIndex(index);
        paginationContainerApi?.scrollTo(index);
    }


    return (
        <div aria-label="room-pagination"
             className="flex justify-center p-4">
            <div className="flex justify-center items-center gap-4">
                <button onClick={prevRoom}
                        className="pagination-button">
                    <CaretIcon className="-rotate-90 size-5"/>
                </button>
                <div className="overflow-hidden max-w-40 lg:max-w-full lg:w-full"
                     ref={paginationContainerRef}>
                    <div className="flex flex-row gap-4">
                    {
                        roomNames.map((name, index) => (
                            <button key={index}
                                    className={`${ roomIndex === index ? "pagination-button-active" : "pagination-button-inactive"}`}
                                    onClick={() => handleRoomClick(index)}>
                                { name }
                            </button>
                        ))
                    }
                    </div>
                </div>
                <button onClick={nextRoom}
                        className="pagination-button">
                    <CaretIcon className="rotate-90 size-5"/>
                </button>
            </div>
        </div>
    )
}

export default RoomPagination;
